export default {
 
}


// WEBPACK FOOTER //
// ./src/Payment/langs/zh_hk/index.js